import { CSSProperties } from "react";

interface RevealAnimationStyleOptions {
  delayMs?: number;
  durationMs?: number;
  easing?: string;
}

export const buildRevealAnimationStyle = (options: RevealAnimationStyleOptions = {}): CSSProperties => {
  const { delayMs = 0, durationMs = 1000, easing = "cubic-bezier(0.22, 1, 0.36, 1)" } = options;

  return {
    transition: `opacity ${durationMs}ms ${easing}, transform ${durationMs}ms ${easing}`,
    transitionDelay: `${delayMs}ms`,
    willChange: "opacity, transform"
  } as CSSProperties;
};
